import React, { useState, useRef } from "react";
import cn from "helpers/classnames";
import useClickOutsideElement from "../../../shared/hooks/useClickOutsideElement";
import InContentAIToolsPopover from "../../../shared/InContentAIToolsPopover";
import { AI_TOOL_READABLE_NAMES } from "../../constants";

const InContentAIHeader = ({ options, selectedOption, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const dismissDropdown = () => setIsOpen(false);

  useClickOutsideElement(ref, dismissDropdown);
  const filteredOptions = options.filter(
    (opt) => opt.full !== selectedOption.full
  );

  const onKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setIsOpen(!isOpen);
    }
  };

  const selectOption = (e, option) => {
    e.preventDefault();
    onSelect(option, dismissDropdown);
  };

  const toggleDropdown = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };

  return (
    <div
      className={cn(
        "ai-form--header tw-border-b tw-border-b-solid tw-rounded-t-lg",
        "tw-border-gray-tint-80 tw-bg-white tw-font-semibold tw-text-center body-1"
      )}
      onClick={toggleDropdown}
      onKeyDown={onKeyDown}
      tabIndex={0}
      data-amplitude={
        selectedOption.full === AI_TOOL_READABLE_NAMES.ASK_AI
          ? "aiContentToolChangeDqg"
          : "aiContentToolChangeAskAi"
      }
      role="button"
      ref={ref}
    >
      <div className="tw-relative tw-flex tw-items-center tw-justify-center tw-h-full">
        <div
          className={cn(
            "tw-flex tw-items-center tw-py-3 tw-px-2.5 tw-justify-center",
            "tw-max-xs:flex-col tw-max-xs:px-[15px] tw-max-xs:py-2.5",
            "tw-cursor-pointer"
          )}
          aria-expanded={isOpen}
        >
          <div className="tw-flex tw-justify-center tw-items-center title">
            <span className="tw-font-semibold tw-text-gray-500 tw-no-underline tw-mr-1">
              <span className="max-md:tw-inline md:tw-hidden lg:tw-inline">
                {selectedOption.full}
              </span>
              <span className="tw-hidden md:tw-inline lg:tw-hidden">
                {selectedOption.abbreviated}
              </span>
            </span>
            <div className="icon-container tw-flex tw-justify-center tw-items-center tw-h-6 tw-w-6">
              <i
                className={cn(
                  "lc-icon lc-icon-xs lc-icon-up tw-h-full tw-rounded",
                  "tw-flex tw-justify-center tw-items-center tw-h-6 tw-w-6",
                  { "tw-hidden": !isOpen }
                )}
              />
              <i
                className={cn(
                  "lc-icon lc-icon-xs lc-icon-down tw-h-full tw-rounded",
                  "tw-flex tw-justify-center tw-items-center tw-h-6 tw-w-6",
                  { "tw-hidden": isOpen }
                )}
              />
            </div>
          </div>
        </div>
        <InContentAIToolsPopover />

        {isOpen && (
          <ul
            className={cn(
              "tw-rounded tw-border-1 tw-border-solid tw-border-[rgba(0,0,0,0.15)]",
              "tw-shadow-[0_4px_8px_rgba(24,25,25,0.18)] tw-text-left tw-py-[5px]",
              "tw-px-0 tw-list-none tw-bg-white tw-rounded-1 tw-mt-[3px]",
              "tw-max-h-[300px] tw-overflow-y-auto tw-absolute tw-z-50 tw-top-full",
              "md:tw-max-h-[285px] tw-w-full"
            )}
            aria-labelledby="Ask LitCharts AI-menu"
          >
            {filteredOptions.map((option) => (
              <li
                className="menu-item tw-border-b tw-border-gray-200 last:tw-border-b-0"
                key={option}
              >
                <button
                  type="button"
                  className={cn(
                    "tw-px-5 tw-py-2 tw-cursor-pointer tw-whitespace-nowrap",
                    "tw-outline-none tw-bg-transparent tw-border-none tw-text-left body-2 tw-w-full"
                  )}
                  data-amplitude="universalHeaderNavLink"
                  data-amplitude-text={option.full}
                  onClick={(e) => selectOption(e, option)}
                >
                  {option.full}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default InContentAIHeader;
